import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "has-first-letter-uppercase has-text-success is-size-5" }
const _hoisted_2 = { class: "has-first-letter-uppercase mb-2" }
const _hoisted_3 = { class: "has-first-letter-uppercase" }
const _hoisted_4 = {
  href: "https://api.elichens.com/doc/public",
  target: "_blank"
}
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = {
  key: 0,
  class: "table"
}
const _hoisted_7 = { class: "text-aq-very-good has-first-letter-uppercase" }
const _hoisted_8 = { class: "text-aq-very-good has-first-letter-uppercase" }
const _hoisted_9 = { class: "text-aq-very-good has-first-letter-uppercase" }
const _hoisted_10 = { class: "text-aq-good has-first-letter-uppercase" }
const _hoisted_11 = { class: "text-aq-good has-first-letter-uppercase" }
const _hoisted_12 = { class: "text-aq-good has-first-letter-uppercase" }
const _hoisted_13 = { class: "text-aq-moderate has-first-letter-uppercase" }
const _hoisted_14 = { class: "text-aq-moderate has-first-letter-uppercase" }
const _hoisted_15 = { class: "text-aq-moderate has-first-letter-uppercase" }
const _hoisted_16 = { class: "text-aq-unhealthy has-first-letter-uppercase" }
const _hoisted_17 = { class: "text-aq-unhealthy has-first-letter-uppercase" }
const _hoisted_18 = { class: "text-aq-unhealthy has-first-letter-uppercase" }
const _hoisted_19 = { class: "text-aq-very-unhealthy has-first-letter-uppercase" }
const _hoisted_20 = { class: "text-aq-very-unhealthy has-first-letter-uppercase" }
const _hoisted_21 = { class: "text-aq-very-unhealthy has-first-letter-uppercase" }
const _hoisted_22 = { class: "text-aq-very-unhealthy has-first-letter-uppercase" }
const _hoisted_23 = { class: "text-aq-very-unhealthy has-first-letter-uppercase" }
const _hoisted_24 = { class: "text-aq-very-unhealthy has-first-letter-uppercase" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "has-text-purple has-first-letter-uppercase" }, /*#__PURE__*/_toDisplayString(100), -1 /* HOISTED */)
const _hoisted_26 = { class: "has-text-purple has-first-letter-uppercase" }
const _hoisted_27 = { class: "has-text-purple has-first-letter-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    width: "80%",
    ref: "modal"
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('map.information.title')), 1 /* TEXT */)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('map.information.description_1')), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('map.information.description_2')), 1 /* TEXT */),
        _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('map.information.aqi_more_info')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: _normalizeClass({ 'is-active': _ctx.currentTab === 'AQI' })
            }, [
              _createElementVNode("a", null, _toDisplayString(_ctx.$t('map.information.tab_elichen_aqi')), 1 /* TEXT */)
            ], 2 /* CLASS */)
          ])
        ]),
        (_ctx.currentTab === 'AQI')
          ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
              _createElementVNode("thead", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('map.information.index')), 1 /* TEXT */),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('map.information.category.title')), 1 /* TEXT */),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('map.information.health_impact_and_recommandation')), 1 /* TEXT */)
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$t('global.from_to', { from: 0, to: 1 })), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('map.information.category.excellent.name')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t('map.information.category.excellent.description')), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('global.from_to', { from: 2, to: 19 })), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('map.information.category.good.name')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('map.information.category.good.description')), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t('global.from_to', { from: 20, to: 39 })), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t('map.information.category.moderate.name')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$t('map.information.category.moderate.description')), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t('global.from_to', { from: 40, to: 59 })), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$t('map.information.category.unhealthy_for_sensitive.name')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$t('map.information.category.unhealthy_for_sensitive.description')), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$t('global.from_to', { from: 60, to: 79 })), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t('map.information.category.unhealthy.name')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$t('map.information.category.unhealthy.description')), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$t('global.from_to', { from: 80, to: 99 })), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$t('map.information.category.very_unhealthy.name')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t('map.information.category.very_unhealthy.description')), 1 /* TEXT */)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_25,
                  _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.$t('map.information.category.hazardous.name')), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.$t('map.information.category.hazardous.description')), 1 /* TEXT */)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}